import { Button, Group, Modal, Text, Tooltip } from "@mantine/core";
import { useLanguage } from "../../stores/LanguageStore";
import { IconTrash } from "@tabler/icons-react";
import { useState } from "react";
import { notifications } from "@mantine/notifications";
import { useDisclosure } from "@mantine/hooks";

const SelectionDeleter = ({
  handleMultipleDelete,
  handleDelete,
  getHandler,
  ids,
  parentId,
  apiRef,
  onFinish,
  setTableLoading,
  rows,
  canRowsDelete,
  disabledMessage,
  buttonTooltip,
  title,
  submitButtonText,
  warningText,
  getParentId,
  setRows,
  disableRowDelete,
  icon,
  closeMenu,
}) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);

  const main = () => {
    if (handleMultipleDelete) {
      setLoading(true);
      closeMenu?.();
      return handleMultipleDelete({ ids, parentId })
        .then((res) => {
          close();
          notifications.show({
            message: lang.components.deletion_action.dialog.multiple_success,
            color: "tertiary.8",
          });

          if (apiRef) {
            apiRef?.current?.setRowSelectionModel([]);

            ids.forEach((id) => {
              document.querySelectorAll(`[data-id='${id}']`).forEach((el) => {
                el.style.animation = `forwards 1.5s deletedAnim ease`;
              });
            });
            setTimeout(() => {
              apiRef?.current?.updateRows(
                ids.map((id) => ({ id, _action: "delete" }))
              );
            }, 750);
          }
          setRows?.((prev) => prev.filter((x) => !ids.includes(x.id)));
          onFinish?.();
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setTableLoading?.(true);
      closeMenu?.();
      let requests = [];
      ids?.forEach((id) => {
        requests.push(
          new Promise((resolve, reject) => {
            let main;
            if (handleDelete) {
              main = handleDelete;
            }
            if (getHandler) {
              let current = rows.find((x) => x.id === id);
              main = getHandler(current);
            }
            main({ id, parent_id: getParentId?.(id) || parentId }).then(
              (res) => {
                if (apiRef && !disableRowDelete) {
                  document
                    .querySelectorAll(`[data-id='${id}']`)
                    .forEach((el) => {
                      el.style.animation = `forwards 1.5s deletedAnim ease`;
                    });
                  setTimeout(() => {
                    apiRef?.current?.updateRows([
                      { id, _action: "delete" },
                      { id: `#${id}`, _action: "delete" },
                    ]);
                  }, 750);
                }

                if (!disableRowDelete) {
                  setRows?.((prev) => prev.filter((x) => !ids.includes(x.id)));
                }
                onFinish?.();
                resolve();
              }
            );
          })
        );
      });

      Promise.all(requests).finally(() => {
        if (apiRef && !disableRowDelete) {
          apiRef.current.setRowSelectionModel([]);
        }
        setTableLoading?.(false);
      });
      close();
    }
  };

  return (
    <>
      <Tooltip label={disabledMessage} disabled={!canRowsDelete?.()}>
        <Button
          variant="light"
          color="red"
          disabled={
            rows
              ? ids.length === 0 ||
                ids.filter(
                  (x) =>
                    rows.find((r) => r.id === x)?.delete_permission === false
                ).length > 0 ||
                canRowsDelete?.()
              : ids.length === 0
          }
          onClick={open}
          leftSection={icon || <IconTrash size={18} />}
          justify="start"
          className="to-red"
        >
          {buttonTooltip || lang.table.toolbar.bulk_deletion.button_tooltip}
        </Button>
      </Tooltip>

      <Modal
        opened={opened}
        onClose={close}
        title={
          title || (
            <Text size="md" truncate="end">
              {lang.components.deletion_action.title}{" "}
              <b>
                {" "}
                {ids.length} {lang.components.deletion_action.elements}{" "}
              </b>
            </Text>
          )
        }
        centered
        styles={{
          content: {
            boxShadow: "red 0 0 6px",
            border: "1px solid #a00",
          },
          title: {
            maxWidth: "92%",
          },
        }}
      >
        {warningText || (
          <Text size="sm">
            {lang.components.deletion_action.dialog.multiple_text} <br />
            <b>{lang.components.deletion_action.dialog.warning_text}</b>
          </Text>
        )}

        <Group justify="end" mt={"sm"}>
          <Button variant="subtle" onClick={close} disabled={loading}>
            {lang.components.deletion_action.dialog.cancel_button}
          </Button>
          <Button color="red" onClick={main} loading={loading}>
            {submitButtonText ||
              lang.components.deletion_action.dialog.submit_button}
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default SelectionDeleter;
